import styled from "styled-components";
import { Colors } from "../../utils/Theme";

const StyledDivider = styled.div<{width: string | number, marginBlock: string | number}>`
border-bottom: solid 1px ${Colors.grey30};
margin-block: ${(props) => props.marginBlock};
width: ${(props) => props.width};
`;
export default StyledDivider;
